import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Centre } from '../models/centre.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CentreService {
    apiUrl = environment.apiUrl;
    centre: Centre[];

    constructor(private http: HttpClient) { }

    getAll(): Observable<Centre[]> {
        return this.http.get(`${this.apiUrl}/centres`).pipe(
            map((res) => {
                this.centre = res['data'];
                return this.centre;
            }),
        catchError(this.handleError));
    }

    getCentresByIds(centresIds: []): Observable<Centre[]> {
        const params = new HttpParams().set('centresIds', centresIds.join('+'));
        return this.http.get(`${this.apiUrl}/centres`, {params: params}).pipe(
            map((res) => {
                this.centre = res['data'];
                return this.centre;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
